import {
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table"
import { useState } from "react"

import { IngestionResponses } from "@tfg/types/endpoints/ingestions"

import { Table } from "~/components/table/Table.tsx"
import { useColumns } from "~/pages/Brand/DataTransfer/Import/columns"

type Props = {
  ingestions: IngestionResponses.Ingestion[]
}

const PAGE_SIZE = 50

export const IngestionsList = ({ ingestions }: Props) => {
  const columns = useColumns()

  const [sorting, setSorting] = useState<SortingState>([
    { id: "createdAt", desc: true },
  ])

  const table = useReactTable({
    data: ingestions,
    columns,
    initialState: {
      pagination: {
        pageSize: PAGE_SIZE,
      },
    },
    state: {
      sorting,
    },
    onSortingChange: setSorting,

    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  return <Table table={table} />
}
